import React, { FocusEventHandler } from "react"
import { TextInputHints } from "../../common/components/TextInputHints"
import Actions from "../marcheBruciatoriActions";
import { formGroup } from "../../common/components/formGroup";

interface Props {
    error?: string;
    onChange: (locality: string | null) => void;
    hidden?: boolean;
    name?: string;
    placeholder?: string;
    label?: string;
    style?: React.CSSProperties;
    readOnly?: boolean;
    value?: string;
    required?: boolean;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
}
export class MarcaBruciatoreAutocomplete extends React.Component<Props> {
    render() {
        var component = (
            <TextInputHints {...this.props}
                ActionsGet={async x => x}
                ActionsSearch={literal => Actions.search(literal).then(({ marche }) => marche)}
            />
        );
        if (this.props.hidden === true) {
            component = (<div />);
        }
        return (component);
    }
}

export const MarcaBruciatoreSelector = formGroup(MarcaBruciatoreAutocomplete);